module.exports = __webpack_public_path__ + "static/media/0130_Small.ff345776.jpg";